"use client";

import { Form } from "@/components/ui/form";
import { TObituaryFull } from "@/types/obituary";
import { scrollToElement } from "@/utils/scroll";
import { zodResolver } from "@hookform/resolvers/zod";
import { Loader2, Trash2 } from "lucide-react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import CustomInput from "../generator/fields/CustomInput";
import CustomTextArea from "../generator/fields/CustomTextArea";

const FormSchema = z.object({
  name: z.string().min(3, {
    message: "Der Name muss mindestens 3 Zeichen lang sein.",
  }),
  email: z.string().email({
    message: "Dies ist keine gültige E-Mail.",
  }),
  message: z.string().min(3, {
    message: "Der Name muss mindestens 3 Zeichen lang sein.",
  }),
  file: z.any(),
});

type Inputs = z.infer<typeof FormSchema>;
type Props = {
  loadBook: () => void;
};

const AddCommentForm = ({ slug, loadBook }: TObituaryFull & Props) => {
  const form = useForm<Inputs>({
    resolver: zodResolver(FormSchema),
    mode: "onChange",
  });
  const [file, setFile] = useState<any>();
  const [isSending, setIsSending] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFileAdded, setIsFileAdded] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    trigger,
    clearErrors,
    resetField,
    formState: { errors },
  } = form;
  function onSubmit(values: z.infer<typeof FormSchema>) {
    sendValuesToApi(values);
  }

  const fileWatch = watch("file");

  const sendValuesToApi = async (values: z.infer<typeof FormSchema>) => {
    setIsSending(true);
    const formData = new FormData();
    formData.append("slug", slug);
    formData.append("name", values.name);
    formData.append("email", values.email);
    formData.append("message", values.message);
    if (values.file[0]?.name) {
      formData.append("file", values.file[0]);
    } else {
      formData.append("file", "none");
    }
    // formData.append("job_id", "9");
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_DOMAIN_ROUTE}/api/obituary/comment/`,
        {
          method: "POST",
          body: formData,
        }
      );
      let resp = await response.json();
      if (resp.name) {
        setIsSuccess(true);
      } else {
        setIsError(true);
      }
    } catch (e) {
      setIsError(true);
    }
    setIsSending(false);
    scrollToElement("initBook");
    reset();
    setValue("name", "");
    setIsFileAdded(false);
    loadBook();
  };

  const onChangeFile = (e: any) => {
    if (e.target.files.length > 0) {
      setFile(URL.createObjectURL(e.target.files[0]));
      setIsFileAdded(true);
    } else {
      setFile(null);
      setIsFileAdded(false);
    }
  };

  const handlerClearPhoto = () => {
    resetField("file");
    setFile(null);
    setIsFileAdded(false);
  };

  let registerFile = register("file");
  return (
    <div className="flex w-full max-w-3xl flex-col gap-4 border border-secondary-200 bg-secondary p-6 text-white">
      <h4>Hinterlassen Sie Ihre Grußbotschaft</h4>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="mx-auto flex w-full flex-col items-center justify-center gap-2"
        >
          <CustomInput
            form={form}
            name="name"
            textError="text-white/50"
            label=""
            placeholder="Ihr Name"
          />
          <CustomInput
            form={form}
            name="email"
            textError="text-white/50"
            label=""
            placeholder="Ihr Email"
          />
          <CustomTextArea
            form={form}
            name="message"
            textError="text-white/50"
            label=""
            placeholder="Schreiben Sie eine Nachricht oder teilen Sie ein Foto!"
          />
          <div className="flex w-full flex-col items-center justify-between gap-2 pt-2 lg:flex-row">
            <div
              className={`w-full lg:w-64 ${isFileAdded ? "hidden" : "flex"}`}
            >
              <label
                htmlFor="file"
                className="button secondary large solid-white w-full"
              >
                {isFileAdded && isSending && (
                  <Loader2 className="h-4 w-4 animate-spin" />
                )}
                {isFileAdded ? "Foto hinzugefügt" : "Foto hinzufügen"}
              </label>
              <input
                {...registerFile}
                id="file"
                className="hidden"
                type="file"
                onChange={(e) => {
                  registerFile.onChange(e);
                  onChangeFile(e);
                }}
              />
            </div>
            {isFileAdded && (
              <div className="relative flex items-center justify-center shadow-lg">
                <img
                  src={file}
                  className="relative h-24 min-w-[96px] max-w-[192px] object-cover"
                />
                <button
                  onClick={() => {
                    handlerClearPhoto();
                  }}
                  className="z-5 absolute right-1 top-1 flex h-10 w-10 items-center justify-center rounded-full border-4 border-secondary-400 bg-secondary text-white hover:bg-secondary-800"
                >
                  <Trash2 className="h-5 w-5" />
                </button>
              </div>
            )}
            <div className="flex flex-row">{isSending}</div>
            <button
              type="submit"
              id="add-comment"
              className="btn secondary large solid-white w-full lg:w-64"
            >
              {isSending && <Loader2 className="h-4 w-4 animate-spin" />}Senden
            </button>
          </div>
        </form>
      </Form>
    </div>
  );
};

export default AddCommentForm;
